import { Body, Cell, Row, Table } from '@calendly/ui/components/table';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { MembershipInfo } from 'features/user_info';
import { getIntegrationNames, userToMembership } from './helpers';
import { TableContainer } from './styles';
const mutedItalicTextCss = "m1hbzon9";
const MutedItalicText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(mutedItalicTextCss, props.className)} />;
});
const IntegrationErrors = ({
  integrations
}) => {
  if (integrations.length === 0) {
    return null;
  }
  const integrationsList = getIntegrationNames(integrations);
  return <Cell align="right">
      <MutedItalicText>
        {[...new Set(integrationsList)].join(', ')}
      </MutedItalicText>
    </Cell>;
};
export const UsersList = ({
  users,
  showCalendarNames = false,
  showVideoConferencingNames = false
}) => {
  if (!users.length) return null;
  return <TableContainer>
      <Table noContainerBorder>
        <Body>
          {users.map(user => <Row key={user.uri}>
              <Cell>
                <MembershipInfo membership={userToMembership(user)} isAvatarNonInteractive />
              </Cell>
              {showCalendarNames && <IntegrationErrors integrations={user.integrations.map(({
            kind
          }) => kind)} />}
              {showVideoConferencingNames && <IntegrationErrors integrations={user.integrations.map(({
            context
          }) => context)} />}
            </Row>)}
        </Body>
      </Table>
    </TableContainer>;
};

require("./users_list.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./users_list.js");